export default __webpack_public_path__ + "static/media/floral4.61bf8438.png";